<template>
  <div class="tag-main">
    <div class="tags">
      <h4 class="title">标签</h4>
      <div class="my-tags">
        <ul>
          <li v-for="tag in tags" :key="tag.id">
            <el-tag class="tag" :class="tagName + tag.tagColor" :disable-transitions="false" closable @close="delTagsHanlder(tag.onlineVisitorTagEntity.tagId, tag)"><span v-html="tag.onlineVisitorTagEntity.tagName"></span></el-tag>
          </li>
        </ul>
      </div>
      <el-dropdown trigger="click" placement="top-start">
        <span class="el-dropdown-link">
          <el-button class="button-new-tag" size="small" @click="getTagsHandler">+ 添加标签</el-button>
        </span>
        <el-dropdown-menu slot="dropdown" class="tags-dropdown-menu">
          <!-- <div class="title">
            <p>添加标签</p>
          </div> -->
          <div v-if="tagShow">
            <el-dropdown-item v-for="tag in tagsList" :key="tag.text" size="small">
              <span class="tag" :class="tagName + tag.colorName" @click="addTagsHandler(tag.id)" v-html="tag.text"></span>
            </el-dropdown-item>
          </div>
          <h3 v-else>暂无标签</h3>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>

  export default {
    /**
     * @Author: xl
     * @NotedTime: 2018.8.18
     * @Email: xule@360shop.cn
     */
    props: ['tags', 'visitorId'],
    data() {
      return {
        isBlack: false, //是否加入黑名单
        tagShow: true, //显示标签数据
        tagName: 'tc-', //标签前缀
        tagsList: [], //获取标签列表
        myTags: [], //添加标签列表
        postData: {
          id: '', //标签名字
          uid: '' //访客id
        }
      }
    },
    methods: {
      /**
       * 【获取标签列表】
       */
      getTagsHandler() {
        this.$http.getTagsList().then(res => {
          if (res.status == 1) {
            this.tagsList = res.data
          } else {
            this.tagShow = false
          }
        })
      },
      /**
       * 【添加标签】
       */
      addTagsHandler (id) {
        const postData = {
          id: id, //标签名字
          uid: this.visitorId //访客id
        }
        this.$http.addTag(postData).then(res => {
          if (res.status == 1) {
            this.tagsList.forEach((item, index) => {
              if (item.id == id) {
                this.tags.push(item)
                this.$emit('chatTags', this.tags)
              }
            })
			this.$message.success(res.msg)
          }
        })
      },
      /**
       * 【删除标签】
       */
      delTagsHanlder (id, tag) {
        const postData = {
          id: id, //标签名字
          uid: this.visitorId //访客id
        }
         this.$http.delTag(postData).then(res => {
          if (res.status == 1) {
            this.tags.splice(this.tags.indexOf(tag), 1)
            this.$message.success(res.msg)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  // @import '~@/assets/css/common/index';

  .tag-main {
    margin-top: 15px;
    .el-tag {
      margin-top: 5px;
      &--small {
        padding: 0 8px!important;
      }
      .el-icon-close {
        color: inherit;
        &:hover {
          background-color: rgba(255, 0, 0, 0.5);
          color: #fff;
        }
      }
    }
    .el-button--mini {
      margin-top: 5px;
      padding: 5px 15px;
    }
    .el-input--mini {
      margin-top: 5px;
      .el-input__inner {
        height: 24px;
        line-height: 24px;
      }
    }
    .tags {
      position: relative;
      color: $mainColor;
      padding: 15px 0;
      border-top: 1px solid #eee;
      // border-bottom: 1px solid $borderColor;
      .title {
        font-size: 12px;
        font-weight: bold;
      }
      .my-tags {
        padding: 5px 0;
        overflow: hidden;
		ul{
			display: flex;
			padding: 0;
		}
        li {
          line-height: 36px;
          padding: 0 10px 0 0;
          .el-tag {
            margin-top: 0;
            margin-right: 0;
            padding: 0 10px;
            height: 24px;
            line-height: 22px;
          }
        }
      }
      .list {
        .tag {
          position: relative;
          margin-bottom: 8px;
          padding: 3px 5px;
          // .fa {
          //   opacity: 0;
          //   position: absolute;
          //   right: -5px;
          //   top: -5px;
          //   height: 15px;
          //   line-height: 15px;
          //   width: 15px;
          //   text-align: center;
          //   border-radius: 50%;
          //   // @include transition;
          // }
          // &:hover {
          //   .fa {
          //     opacity: 1;
          //   }
          // }
        }
      }
      .btn-add-tag {
        background-color: #fff;
        color: #46b8da;
        height: 24px;
        line-height: 24px;
        display: inline-block;
        padding: 0 6px;
        font-size: 12px;
        text-align: center;
        border-radius: 2px;
        border: 1px solid #46b8da;
        &:hover {
          background-color: #5bc0de;
          color: #fff;
          text-decoration: none;
        }
      }
      .popup-addTags {
        // display: none;
        position: absolute;
        bottom: 50px;
        left: 10px;
        width: 200px;
        background: #fff;
        box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
        border-radius: 5px;
        &::after {
          display: block;
          content: " ";
          position: absolute;
          left: 10px;
          bottom: -20px;
          border: 10px solid #fff;
          border-color: #fff transparent transparent transparent;
          z-index: 1;
        }
        .popup-addTags-title {
          line-height: 26px;
          font-size: 14px;
          text-align: center;
          color: #101010;
          border-radius: 5px 5px 0 0;
          background: #F7F7F7;
        }
        .popup-addTags-tagsPanel {
          padding: 10px;
        }
        .tag {
          margin-bottom: 5px;
          .fa {
            display: none;
          }
        }
      }
    }
    .blacklist {
      padding: 15px 0;
      overflow: hidden;
      .el-button {
        font-size: 12px;
        color: $mainColor;
        .svg-icon {
          margin: 0 5px 2px 0;
        }
      }
    }
  }
  .tags-dropdown-menu {
    width: 225px;
    padding: 0 15px 10px;
    .title {
      // margin: 0 -15px 10px;
      background: #ebedf0;
      border-radius: 4px 4px 0 0;
      p {
        line-height: 30px;
        padding: 0 10px;
        color: #808080;
      }
    }
    h3 {
      text-align: center;
      padding: 10px 0;
    }
    .el-dropdown-menu__item {
      float: left;
      padding: 0 5px;
      &:hover {
        background: #fff;
        color: inherit;
      }
      .tag {
        height: 24px;
        line-height: 22px;
        margin-right: 0;
        padding: 0 10px;
      }
    }
  }
</style>
